export default {
  main: '#E9DBC0',
  secondary: '#2D693E',
  contrastingColor: '#000000',
  priceColor: '#2D693E',
  entryBackground: '#E9DBC0',
  menuBackgroundColor: '#000000',
  menuTextColor: '#ffffff',
};
